<app-nav-bar>
  <ul mobile class="nav-bar__mobile__items">
    @if (canViewDeviceSettingsButton$ | async) {
      <li class="nav-bar__mobile__item">
        <button (click)="openChangeAudioVideoModal()" data-testid="header-device-settings">
          Device Settings
        </button>
      </li>
    }

    @if (canViewOrderDetailsButton$ | async) {
      <li class="nav-bar__mobile__item">
        <button (click)="openDetailsModal()" data-testid="header-order-details">Order Details</button>
      </li>
    }
    <li class="nav-bar__mobile__item" data-testid="header-privacy-policy">
      <a target="_blank" href="https://www.rocketclose.com/privacy-policy" rel="noopener"
        >Privacy Policy</a
        >
      </li>
      <li class="nav-bar__mobile__item" data-testid="header-terms-of-use">
        <a target="_blank" href="https://www.rocketclose.com/terms-of-use" rel="noopener">Terms of Use</a>
      </li>
      <li class="nav-bar__mobile__item">
        <button (click)="openCancelSigningModal()" data-testid="header-cancel-signing">
          Cancel Signing
        </button>
      </li>
      <li class="nav-bar__mobile__item">
        <app-support-phone-number-button></app-support-phone-number-button>
      </li>
    </ul>

    <app-support-phone-number-button></app-support-phone-number-button>

    <app-menu
      [isDeviceSettingsButtonEnabled]="canViewDeviceSettingsButton$ | async"
      [isOrderDetailsButtonEnabled]="canViewOrderDetailsButton$ | async"
      [isPrivacyPolicyButtonEnabled]="true"
      [isTermsOfUseButtonEnabled]="true"
      [isCancelSigningButtonEnabled]="true"
    ></app-menu>

  </app-nav-bar>
